import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { MediaCSSVars } from '@wix/thunderbolt-components-native';
import type {
  SectionDefinition,
  SectionProps,
} from '@wix/thunderbolt-components';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  SectionProps,
  SectionDefinition,
  SectionProps
>()(['experiments'], ({ experiments }, carmiData) => {
  const useWixMediaCanvas = isExperimentOpen(
    experiments,
    'specs.thunderbolt.useWixMediaCanvas',
  );
  const { fillLayers } = carmiData;
  return {
    ...carmiData,
    fillLayers: {
      ...fillLayers,
      useWixMediaCanvas,
    },
  };
});

export const css = withCompInfo<
  MediaCSSVars,
  SectionDefinition,
  MediaCSSVars
>()([], (_, carmiCss) => {
  return {
    ...carmiCss,
    '--inherit-transition': 'var(--transition, none)',
  };
});

export default createComponentMapperModel({ props, css });
